import axios from "axios";
import config from "../config";
import store from "../store/store";

// 创建 Axios 实例
const httpClient = axios.create({
  baseURL: config.googleSheetBaseUrl,
});

function _getSpreadSheetMetaData() {
  const googleSheetId = store.getters['basic/googleSheetId']
  return httpClient.get(`${googleSheetId}?key=${config.googleSheetKey}`);
}

function _get(sheet) {
  const googleSheetId = store.getters['basic/googleSheetId']
  // 送出完整 url 範例： `${baseUrl}${config.googleSheetId}/values/${path}?alt=json&key=${config.googleSheetKey}`
  // return httpClient.get(`${goodSheetId}/values/${path}?alt=json&key=${config.googleSheetKey}`);
  return httpClient.get(`${googleSheetId}/values/${sheet}?alt=json&key=${config.googleSheetKey}`);
}

httpClient.interceptors.response.use((response) => {
  // 成功處理 API 回應
  return response;
}, (error) => {
  // 處理錯誤
  console.error('API error', error);
  const status = error?.response?.status;
  if (status) {
    console.error('API error, status: ', status);
  }
  if (status > 400 && status < 500) {
    // TODO
  }

  return Promise.reject(error);
});

export const getSpreadSheetMetaData = async () => _getSpreadSheetMetaData()
export const getSpreadSheetDataBySheetName = async (sheet) => _get(sheet)

// 分類
// 套餐
// 餐點
// 規格
// 套餐子項
// 替換子項
// 任選子項
// 全單規格
// 用餐區域桌號
